import React, { Component } from 'react';
import { connect } from 'react-redux'
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import './actionsTa.css';
import FetchData from '../../Utils/FetchData';
import setActionMessage from '../../../actions/setActionMessage';
import setActionDashboardlist from '../../../actions/setActionDashboardlist';
import setActionRefreshDashboard from '../../../actions/setActionRefreshDashboard';
import setActionID from '../../../actions/setActionID';
import setActionURL from '../../../actions/setActionWbdvUrl';
import setActionta from '../../../actions/setActionsta';
import setLocalActions from '../../../actions/setLocalActions';
import setActionName from '../../../actions/setActionName';
import notify from 'devextreme/ui/notify';
import { Redirect , Link } from "react-router-dom";
import TabPanel from 'devextreme-react/tab-panel';
import Tabs from 'devextreme-react/tabs';
import inspectionIconTitle from '../../../images/iconDocInspection.png'
import inspectionIcon from '../../../images/inspectionIcon.png'
var modal;
var arrayLocalAction = [];
var selectedIndexTab=0;
window.addEventListener("message", function (message) {
   
})
class actionsTA extends React.Component {
    constructor(props) {

        super(props);
        this.onTabsSelectionChanged = this.onTabsSelectionChanged.bind(this);
       /* this.ViewMaintenanceReport = this.ViewMaintenanceReport.bind(this);*/
        //this.msgHandler = this.msgHandler.bind(this);
        this.state = {
            actionsta: [],
            actionId: '',
            roleid: this.props.roledataId,
            objectId:this.props.objectId,
            message: '',
            widthResolution: window.innerWidth,
            selectedIndex: '',
            tabsInspection: [{
                ID: 1,
                text: 'New',

            }, {
                ID: 2,
                text: "Import",

            }]

        };
        this.containerEl = null;
        this.externalWindow = null;
        if (this.props.folderViewKey !== undefined) {

            this.fetchActions()
        }
    }
    //shouldComponentUpdate(nextProps, nextState) {
    //    if (nextState.selectedIndex != this.state.selectedIndex) {
    //        return true;
    //    }
    //    if (nextState.actionsta != this.state.actionsta) {
    //        return true;
    //    }
    //}
  
    handleResize = () => this.setState({
        widthResolution: window.innerWidth,

    });
    componentDidMount() {
       /* objectid: this.props.objectId,*/
       
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
       
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }
    componentDidUpdate(prevProps, prevState) {
      
      
        if (this.props.taskcontextExpandCollapse === true) {
           
            if (this.state.widthResolution === 1920 && this.state.widthResolution < 2132) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "99%";
                } else if (this.props.folderExpandCollapse === true) {
                    document.getElementById("action").style.width = "74.3%";
                }
                else {
                    document.getElementById("action").style.width = "67.3%";
                }

            }
            if (this.state.widthResolution > 2132) {
              
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "77%";
                } else {
                    document.getElementById("action").style.width = "74.5%";
                }
            }
            if (this.state.widthResolution >= 2100 && this.state.widthResolution < 2132) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "77%";
                } else {
                    document.getElementById("action").style.width = "74.5%";
                }
            }
            if (this.state.widthResolution >= 2064 && this.state.widthResolution < 2100) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "77%";
                } else {
                    document.getElementById("action").style.width = "74.5%";
                }
            }
            if (this.state.widthResolution > 1759 && this.state.widthResolution < 1920) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "77%";
                } else {
                    document.getElementById("action").style.width = "66.5%";
                }
            }
            if (this.state.widthResolution > 1535 && this.state.widthResolution < 1600) {
              
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "77%";
                } else {
                    document.getElementById("action").style.width = "60.5%";
                }
            }
            if (this.state.widthResolution > 1599 && this.state.widthResolution < 1620) {
                
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "74%";
                } else {
                    document.getElementById("action").style.width = "61.2%";
                }
            }
            if (this.state.widthResolution > 1442 && this.state.widthResolution < 1535) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "100%";
                } else {
                    document.getElementById("action").style.width = "61.2%";
                }
            }
            if (this.state.widthResolution <= 1441) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "67%";
                } else {
                    document.getElementById("action").style.width = "56.5%";
                }
            }

            if (this.state.widthResolution > 1680 && this.state.widthResolution < 1708) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "100%";
                } else {
                    document.getElementById("action").style.width = "52%";
                }
            }
            if (this.state.widthResolution === 1776) {
              
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "78%";
                } else {
                    document.getElementById("action").style.width = "65.5%";
                }
            }
            if (this.state.widthResolution === 1745) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "100%";
                } else {
                    document.getElementById("action").style.width = "66%";
                }
            }
           
            if (this.state.widthResolution > 1679 && this.state.widthResolution < 1681) {
               
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "83%";
                } else {
                    document.getElementById("action").style.width = "63.3%";
                }
            }
            //document.getElementById("action").style.width = "73%";
        }
        if (this.props.taskcontextExpandCollapse === false) {

            if (this.state.widthResolution === 1440) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "99%";
                } else {
                    document.getElementById("action").style.width = "74.5%";
                }
            }
            if (this.state.widthResolution === 1536) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "86%";
                } else {
                    document.getElementById("action").style.width = "77%";
                }
            }
            if (this.state.widthResolution === 1600) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "86%";
                } else {
                    document.getElementById("action").style.width = "77%";
                }
            }
            if (this.state.widthResolution > 1679 && this.state.widthResolution < 1681) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "99%";
                } else {
                    document.getElementById("action").style.width = "78%";
                }
            }
            if (this.state.widthResolution > 1680 && this.state.widthResolution < 1708) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "99%";
                } else {
                    document.getElementById("action").style.width = "78%";
                }
            }
            if (this.state.widthResolution === 1776) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "94%";
                } else {
                    document.getElementById("action").style.width = "79.2%";
                }
            }
            if (this.state.widthResolution === 1745) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "99%";
                } else {
                    document.getElementById("action").style.width = "79.2%";
                }
            }

            if (this.state.widthResolution === 1920) {

                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "99%";
                } else if (this.props.folderExpandCollapse === true && this.props.taskcontextExpandCollapse === false) {
                    document.getElementById("action").style.width = "87%";
                } else if (this.props.folderExpandCollapse === true && this.props.taskcontextExpandCollapse === true) {
                    document.getElementById("action").style.width = "86%";
                }
                else {
                    document.getElementById("action").style.width = "91%";
                }


            }
            if (this.state.widthResolution > 1920) {
                if (this.props.folderExpandCollapse === false) {
                    document.getElementById("action").style.width = "99%";
                } else {
                    document.getElementById("action").style.width = "85%";
                }

            }

        }
        if (prevProps.folderViewKey !== this.props.folderViewKey) {

            this.props.actionDashboardlistset(undefined)
            this.fetchActions()
        }
        if (this.props.refreshdashboardlist != undefined) {
            this.actionID(this.props.actionId)
        }
        if (prevProps.roledataId !== this.props.roledataId && prevProps.roledataId != this.props.roledataId) {
            this.setState({ actionsta: undefined })
        }

    }
    confirmDelete() {
        document.getElementById("actionModal").style.display = "none"
        this.props.actionMessageset("Ok")
    }
    handleCloseModal() {
        document.getElementById("actionModal").style.display = "none"
        document.getElementById("actionModaInspection").style.display = "none"
    }
    openInspectionModal=()=> {
        selectedIndexTab = 0
        this.setState({ selectedIndex:'0'})
        document.getElementById("actionModaInspection").style.display = "block"
    }
    iframeId = (i) => {
       // alert('1')
        this.props.ActionsName(undefined)
       // if (this.props.objectId.length > 1) {
       //     alert('Please select one Object ID EVENT')
       // }
      
       // this.props.ActionURLset(i)
       // var url = 'WBDV?flag=' + i
        
        window.open('iframe',i,"width=900,height=950,left=400''");
       // window.open('http://localhost/home', i, 'width=860,height=600')
      
    }
    ViewMaintenanceReport = (e) => {
        //alert('ViewMaintenanceReport')
        window.open(e + "?roleid=" + this.state.roleid + "&objectId=" + this.props.objectId + "&vessel=" + this.props.currRow[0].shipname + "&userid=" + this.props.usedataState, "second", "toolbar=no, location=no, statusbar=1, menubar=no, scrollbars=1, resizable=0, width=1280, height=800, top=100 , left = 500")
   
       
    }
    actionID = (id) => {
        
       
        this.props.ActionsLocalset(arrayLocalAction)
        var objectsArray = [];

        this.props.ActionIdset(id)
        var currentAction = this.state.actionsta.find(a => a.id === id)
      
       
        this.props.ActionsName(currentAction.displayName)
        
        if (currentAction.displayName === 'Show Analytics') {
          
            FetchData('/api/showanalytics/DashboardNamesList/' + this.props.folderIdState + '/' + this.props.usedataState)
                .then(data => {

                    this.props.actionDashboardlistset(data.data)
                   
                    if (data.data.length > 1) {
                        modal = document.getElementById("Modal");

                        var span = document.getElementsByClassName("close")[0];
                        var button = document.getElementsByClassName("Modal100-form-btn")[0]

                        modal.style.display = "block";
                    } else {
                        alert('No global dashboard is set!')
                    }

                }).catch(function (error) {

                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Error while get dashboard data, please log in again.')
                        window.location.href = '/';
                    }
                })


        } else if (currentAction.isWebInteractiveUser === true ) {
           // alert('currentAction.isWebInteractiveUser === true ')
            var selectedContext
            if (this.props.contextSelectionState !== undefined) {
                if (this.props.contextSelectionState[0].root !== undefined) {
                    selectedContext = this.props.contextSelectionState[0].id
                } else {
                    selectedContext = null
                }
            }
           
          
            var actionDetailsVar = id + selectedContext + this.props.objectId
          
            /*this.props.ActionURLset('http://www.google.com')*/
            this.props.ActionURLset(currentAction.wsResourceCall)
           
            var dimensionsBDV = currentAction.webBDVSize.split('x')
            //alert(actionDetailsVar)
            if (id !== 'false') {
              
                window.open('iframe','qrcode', "width=" + dimensionsBDV[1] + ",height=" + dimensionsBDV[0] + ",left=500,top=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=1,resizable=no");
             /*   window.open('iframe', actionDetailsVar, "width=" + dimensionsBDV[1] + ",height=" + dimensionsBDV[0] + ",left=500,top=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=1,resizable=no");*/

            } else {
             
                window.open('iframe', actionDetailsVar, "width=" + dimensionsBDV[1] + ",height=" + dimensionsBDV[0] +",left=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=1,resizable=1");

            }
           // window.open('iframe', actionDetailsVar, "width=800,height=755,left=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,resizable=no");

        }
        else {
            //notify({ position: "top right", message: "Action Success", width: 50 }, "success", 1200);
            notify({ message: "Action Success", width: 50 }, "success", 1200);
            this.setState({ actionId: id })
            var contextSelection
            var contextRoots
            var contextParents
            if (this.props.contextSelectionState !== undefined) {

                contextSelection = this.props.contextSelectionState.map((c) => '{' + c.id + '}:{' + c.beid + '}').join(',')
                contextRoots = this.props.contextSelectionState.map((c) => c.root).join(':')
                contextParents = this.props.contextSelectionState.map((c) => c.parent).join(':')
            }
            var objectID

            if (this.props.objectId !== undefined) {
                for (var i = 0; i < this.props.objectId.length; i++) {
                    objectsArray.push({ idObject: this.props.objectId[i] })
                }
            }
            if (objectsArray !== undefined) {
                objectID = objectsArray.map((c) => c.idObject).join(':')
            }

            var postparameters = "{'parameters':[\
                        {'name':'<CURRENTUSER>','value':'"+ this.props.usedataState + "','pType':'i' },\
                        {'name':'<CURRENTTASK>','value':'"+ this.props.taskIdState + "','pType':'i' },\
                        {'name':'<CURRENTROLE>','value':'"+ this.props.roledataId + "','pType':'i' },\
                        {'name':'<CURRENTIDOBJECT>','value':'"+ objectID + "','pType':'s' },\
                        {'name':'<USERCONTEXTTEMPLATE>','value':'"+ this.props.contextTemplateIdState + "','pType':'as' },\
                        {'name':'<USERROOTCONTEXTSELECTION>','value': '"+ contextRoots + "','pType':'as' },\
                        {'name':'<USERPARENTCONTEXTSELECTION>','value': '"+ contextParents + "','pType':'as' },\
                        {'name':'<USERCONTEXTSELECTION>', 'value': '"+ contextSelection + "', 'pType': 'as' } \
                    ]}";
            FetchData('/api/Actions/InvokeAction/' + id, 'POST', postparameters)
                .then(data => {
                   
                    this.props.actionMessageset(data.messages[0])

                }).catch(function (error) {

                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Your login session has expired, please log in again.')
                        window.location.href = '/';
                    }
                })
        }
        this.props.refreshDashboardlistset(undefined)

    }
    fetchActions() {
      
      
        FetchData('/api/Actions/GetActionsByFolderId/' + this.props.roledataId + '/' + this.props.taskIdState + '/' + this.props.folderViewKey)
            .then((data) => {
               
                this.props.ActionTAset(data.data)
                this.setState({
                    actionsta: data.data,
                })


            }).catch(function (error) {
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            });


    }
    itemTitleRender(name) {
        return <span>{name.Name}</span>;
    }
    onTabsSelectionChanged(args) {
      
        selectedIndexTab = args.value
        if (args.name === 'selectedIndex') {
            
            this.setState({
                selectedIndex: args.value,
            });
        }
    }
    designerInspection = (e) => {
        var actionDetailsVar = 'http://10.30.0.35:9000/ManageInspectionForms?edit=false'
        var dimensionsBDV = '1200'
        this.props.ActionURLset('http://10.30.0.35:9000/ManageInspectionForms?edit=false')
        window.open('iframe', actionDetailsVar, "width=" + dimensionsBDV + ",height=" + dimensionsBDV + ",left=500,top=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=1,resizable=no");
    }
    importInspection = (e) => {
        this.setState({ selectedFile: e.target.files[0] });
        //var actionDetailsVar = 'http://localhost:5000/InspectionIframe'
        var actionDetailsVar = 'http://10.30.0.35:6060/InspectionIframe'
       
        var dimensionsBDV = '1200'
        this.props.ActionURLset('http://10.30.0.35:6060/InspectionIframe')
        window.open('iframe', actionDetailsVar, "width=" + dimensionsBDV + ",height=" + dimensionsBDV + ",left=500,top=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=1,resizable=no");
    }
    fileData = () => {
        if (this.state.selectedFile) {

            return (

                <div style={{ fontSize: '14px', marginLeft: '50%', color: '#111', fontWeight: '500', marginTop:'-40px' }}>
                    <h2 style={{ fontSize: '14px', color: '#111', fontWeight: '500' }}>File Name: {this.state.selectedFile.name}</h2>
                   
                   
                </div>

            );
        } 
    };
    toggleWindowPortal = () => {
        this.props.ActionURLset('http://localhost:5003/ManualDocumentBdv')
        var actionDetailsVar = 'http://10.30.0.35:6060/InspectionIframe'
        var dimensionsBDV = '1200'
        window.open('iframe', actionDetailsVar, "width=" + dimensionsBDV + ",height=" + dimensionsBDV + ",left=500,top=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=1,resizable=no");
    }
    render() {
      
        var renderTabContaint;
      
        if (selectedIndexTab === 0 || this.state.selectedIndex === '0') {
            renderTabContaint = <div className="dx-field">
                <div className="dx-field-label" style={{ marginTop: '-10px', cursor: 'pointer' }}>
                    <img style={{ height: '30px', width: '30px', marginRight: '10px' }} src={inspectionIcon} />
                    <span class="btn btn-primary btn-file" onClick={this.designerInspection}>
                        Create Inspection Form 
                    </span> 
                   
                     </div>
            </div>
        } else {
            renderTabContaint = <div className="dx-field">
                

                <div className="dx-field-label" style={{ marginTop: '-10px', cursor: 'pointer' }} onClick={this.handleSubmit} >
                    <img style={{ height: '30px', width: '30px', marginRight: '10px', cursor: 'pointer' }} src={inspectionIcon} />                 
                    <span class="btn btn-primary btn-file" style={{ cursor: 'pointer' }}>
                        Import Inspection Form  <input
                            accept=".zip,.rar,.7zip,.html"
                            id="inspection"
                            name="inspection"
                            style={{ cursor: 'pointer' }}
                            type="file"
                            onChange={this.importInspection}
                        />
                       
                    </span>
                    {
                        this.fileData()
                    }
                </div>
            </div>
        }
        const { selectedIndex } = this.state;
        var marginTop;
        var widthResolution = window.innerWidth

        var actionsTa


        if (this.state.actionsta != undefined) {

            actionsTa = this.state.actionsta.map((i, key) => {
               
                if (i != null) {
                    var firstWord = i.name.replace(/ .*/, '')
                    var ico;

                    const expr = firstWord;
                    switch (expr) {
                        //case 'View':
                        //    ico = "glyphicon glyphicon-file"
                        //    break;
                        //case 'Print':
                        //    ico = "glyphicon glyphicon-print"
                        //    break;
                        //case 'Export':
                        //    ico = "glyphicon glyphicon-cloud-download"
                        //    break;
                        //case 'Delete':
                        //    ico = "glyphicon glyphicon-remove"
                        //    break;
                        //case 'Send':
                        //    ico = "glyphicon glyphicon-send"
                        //    break;
                        //case 'Copy':
                        //    ico = "glyphicon glyphicon-copy"
                        //    break;
                        //case 'Report':
                        //    ico = "glyphicon glyphicon-equalizer"
                        //    break;

                        //case 'Schedule':
                        //    ico = "glyphicon glyphicon-calendar"
                        //    break;
                        default:
                            ico = "glyphicon glyphicon-file"
                    }
                    var booleanSettingButton = i.dataInput;
                    var disableActions = true
                
                    if (i.dataInput === 0) {
                        disableActions = false
                    }
                    if (i.dataInput === 1) {
                        if (this.props.objectId !== undefined) {
                            if (this.props.objectId.length > 0) {
                                disableActions = false
                            }
                        }
                    }
                    if (i.dataInput === 2) {
                        if (this.props.objectId !== undefined) {
                            if (this.props.objectId.length > 1) {
                                disableActions = false
                            }
                        }
                    }
                    if (i.dataInput === 3) {
                        if (this.props.objectId !== undefined) {
                            if (this.props.objectId.length === 1 && this.props.objectId.length > 0 && this.props.objectId.length < 2) {
                                disableActions = false
                            }
                        }

                    }

                    if (this.props.workplaceData.length > 0) {

                        if (i.name === 'Show Analytics') {

                            disableActions = false
                        }
                    } else {

                        if (i.name === 'Show Analytics') {

                            disableActions = true
                        }
                    }

                    return (
                       
                            <button className="btn btn-block btn-social btn-social btn-bitbucket" disabled={disableActions} onClick={this.actionID.bind(this, i.id)}>
                                {/*<i className={ico} style={{ marginTop: '-4px' }}></i>*/}
                                {i.icon !== null ?
                                    <img style={{ width: '18px', height: '18px', marginTop: '5px', marginLeft: '5px' }} src={'data:image/png;base64,' + i.icon} /> :
                                    <i className={ico} style={{ marginTop: '-4px' }}></i>
                                }
                                <span style={{ marginLeft: '22px' }}> {i.displayName}
                                </span>
                            </button>

                    )
                }
            });

        }

        return (
            <div>
                <div id="actionModaInspection" class="modalInspection">
                    <div className="modal-contentInspection">
                        <span className="closeInspection" onClick={this.handleCloseModal}>&times;</span>
                        <div style={{ width: '100%', border: '1px ,solid , #111' }}>
                            <span style={{ fontSize: '18px', fontWeight: '40', width: '90%', float:'left' }}>
                                New Form Template 

                            </span>
                            <span style={{ fontSize: '18px', fontWeight: '40' ,float:'right' }}>
                                <img style={{ height: '30px', width: '30px', marginRight: '10px' }} src={inspectionIconTitle} />

                            </span>
                        </div>
                       <br/><br/>
                        <span style={{ fontSize: '14px', fontWeight: '40' }}>
                            Use this facility to create a new draft form template. You can  create from blank document, import
                            an existing document file or create from an existing form template.
                        </span>
                        <hr />
                        <Tabs
                            dataSource={this.state.tabsInspection}
                            selectedIndex={selectedIndex}
                            onOptionChanged={this.onTabsSelectionChanged}
                        />
                        <div className="content dx-fieldset">
                            <div className="dx-field">
                                <div className="dx-field-label">Select a form template technology for your new form template:</div>
                               
                            </div>
                            <div className="dx-field">
                                <div className="dx-field-label" style={{ marginTop: '-10px' }}>Supported Form Technologies:</div>
                            </div>
                            <hr />
                            {renderTabContaint}
                        </div>
                        {/*<div class="modal-footerTaskview" style={{ float: 'right', marginTop: '23px'  }}>

                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal}>Open</button>
                        </div>*/}
                        {/*<div class="modal-footerTaskview" style={{ float: 'right', marginTop: '23px', marginRight:'7px' }}>
                           
                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal}>Close</button>
                        </div>*/}
                      
                    </div>
                </div>
                <div id="actionModal" class="modalTaskview">
                    <div className="modal-contentTaskview">
                        <span className="closeTaskview">&times;</span>
                        <img style={{ width: '60px', height: '50px', backgroundColor: '#ffffff' }} src={require('../../../images/alert.png')} />
                        <p>ALERT</p>
                        <span style={{ fontSize: '20px', fontWeight: '40' }}>
                            Are you sure you want to delete this Dry Dock Event?
                    </span>
                        <div class="modal-footerTaskview" style={{ float: 'right', marginTop: '7px' }}>
                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.confirmDelete}>OK</button>
                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
                <div style={{ borderTop: '0px double #ddd !important;' }}  >
                    <div id="action" className="box-body demo-social" style={{ position: 'absolute', bottom: '1px', marginLeft: '0px', height: 'auto', overflowY: 'auto', borderTop: 'solid 1px #ccc' }}>
                        {actionsTa}
                        {/*<button onClick={this.openInspectionModal} className="btn btn-block btn-social btn-social btn-bitbucket">New</button>*/}
                        {/*<button onClick={this.toggleWindowPortal} className="btn btn-block btn-social btn-social btn-bitbucket">Create Inspection Template</button>*/}
                        
                     
                       
                    </div>
                </div>
            </div>
        );
    }
   
}

const mapStateToProps = state => {
    return {
        refreshdashboardlist: state.currRefreshDashboardState,
        actionId: state.currActionIdState,
        folderViewKey: state.folderDataViewKey,
        taskIdState: state.taskDataId,
        roledataId: state.roleDataId,
        objectId: state.currentObjectID,
        usedataState: state.userData,
        folderIdState: state.folderDataId,
        dashboardlist: state.currDashboardlistState,
        contextConfig: state.currentContextConfiguration,
        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        folderExpandCollapse: state.currFolderExpandCollapse,
        objectALL: state.currentObject,

    }
};
const mapDispatchToProps = dispatch => {
    return {
        actionMessageset: payload => dispatch(setActionMessage(payload)),
        actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        refreshDashboardlistset: payload => dispatch(setActionRefreshDashboard(payload)),
        ActionIdset: payload => dispatch(setActionID(payload)),
        ActionURLset: payload => dispatch(setActionURL(payload)),
        ActionTAset: payload => dispatch(setActionta(payload)),
        ActionsLocalset: payload => dispatch(setLocalActions(payload)),
        ActionsName: payload => dispatch(setActionName(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(actionsTA);




// WEBPACK FOOTER //
// ./src/components/TaskView/WorkPlace/actionsTA.js